<!--<h4>Getting Started</h4>-->
<p>
    The My Courses widget pulls information in real-time from our Canvas Learning Management System. If a course title is a blue link, you can click directly into Canvas. If a course title is black, the instructor has not published the Canvas course or does not use Canvas for course material.
</p>
<div class="list-group list-group-bordered mb-3">
    <div class="list-group-item list-group-item-action">
        <div class="list-group-item-body">
            <div class="fa-stack">
                <i class="my-courses-course__warning far fa-circle fa-stack-2x"></i>
                <strong class="fa-stack-1x black-text">W</strong>
            </div>
            Waitlisted
        </div>
    </div>
    <div class="list-group-item list-group-item-action">
        <div class="list-group-item-body">
            <div class="fa-stack">
                <i class="my-courses-course__warning far fa-circle fa-stack-2x"></i>
                <strong class="fa-stack-1x black-text">5</strong>
            </div>
            Waitlisted and rank is displayed
        </div>
    </div>
    <div class="list-group-item list-group-item-action">
        <div class="list-group-item-body">
            <div class="fa-stack">
                <i class="my-courses-course__warning far fa-circle fa-stack-2x"></i>
                <strong class="fa-stack-1x black-text">A</strong>
            </div>
            Audited
        </div>
    </div>
    <div class="list-group-item list-group-item-action">
        <div class="list-group-item-body">
            <div class="fa-stack">
                <i class="my-courses-course__warning far fa-circle fa-stack-2x"></i>
                <strong class="fa-stack-1x blue-text">C</strong>
            </div>
            Waitlisted with conflicts to manage
        </div>
    </div>
    <div class="list-group-item list-group-item-action">
        <div class="list-group-item-body">
            <div class="fa-stack">
                <i class="my-courses-course__warning far fa-circle fa-stack-2x"></i>
                <strong class="fa-stack-1x blue-text"><i class="fas fa-arrow-down"></i></strong>
            </div>
            Selected to drop if promoted from a waitlist
        </div>
    </div>
</div>
<hr />
<p><strong>Classmates Button</strong></p>
<p>
    <button class="btn btn-sm btn-primary mr-1 mt-1">Classmates</button>
</p>
<p>
    The My Courses widget shows the Classmates button for courses which have started but not ended and courses which start in the next two weeks.
</p>
<hr />
<p><strong>Week Days Abbreviations</strong></p>
<table class="table-sm">
    <thead>
        <tr>
            <th scope="col">Abbrev</th>
            <th scope="col">Day</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>U</td>
            <td>Sunday</td>
        </tr>
        <tr>
            <td>M</td>
            <td>Monday</td>
        </tr>
        <tr>
            <td>T</td>
            <td>Tuesday</td>
        </tr>
        <tr>
            <td>W</td>
            <td>Wednesday</td>
        </tr>
        <tr>
            <td>R</td>
            <td>Thursday</td>
        </tr>
        <tr>
            <td>F</td>
            <td>Friday</td>
        </tr>
        <tr>
            <td>S</td>
            <td>Saturday</td>
        </tr>
    </tbody>
</table>




